(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sentinel = document.getElementById('infinite-scroll-sentinel');
  if (!sentinel) return;

  var productList = document.getElementById('product-list');
  var loading = false;

  function loadNextPage() {
    var url = sentinel.dataset.nextUrl;
    if (!url || loading) return;
    loading = true;
    sentinel.classList.add('is-loading');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelectorAll('#product-list > li');
        newItems.forEach(function (li) {
          productList.appendChild(li);
        });

        var nextSentinel = doc.getElementById('infinite-scroll-sentinel');
        if (nextSentinel && nextSentinel.dataset.nextUrl) {
          sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
          sentinel.classList.remove('is-loading');
          loading = false;
        } else {
          observer.unobserve(sentinel);
          sentinel.remove();
        }
      })
      .catch(function () {
        sentinel.classList.remove('is-loading');
        loading = false;
      });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) loadNextPage();
    });
  }, { rootMargin: '400px' });

  observer.observe(sentinel);
})();

  } catch(e) { console.error(e); }
})();
})();
